import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import * as FileSaver from 'file-saver';
import { DownloadResponse, IoniconsOutline, MAX_PDF_ZOOM, MIN_PDF_ZOOM, PDF_ZOOM_STEP } from '@pt/pt-models';

@Component({
  selector: 'pt-html-preview',
  template: `
    <pt-full-dialog-header
      [title]='title | async'
      [titleIcon]='IconFile'
      (close)='activeModal.close(false)'>
      <ng-container center>
        <pt-pdf-action
          [disabledZoomDown]='disabledZoomDown'
          [disabledZoomUp]='disabledZoomUp'
          [currentPage]='currentPage'
          [totalPage]='totalPage'
          (zoomMax)='zoomMax()'
          (zoomDown)='zoomDown()'
          (zoomUp)='zoomUp()'>
        </pt-pdf-action>

      </ng-container>

      <ng-container right>
        <button type='button' class='d-inline-flex btn btn-link text-white ms-auto'
                aria-label='Close'
                (click)='print()'>
          <pt-icon [key]='IconPrint' [size]='18'></pt-icon>
        </button>
        <button type='button'
                class='d-inline-flex btn btn-link text-white'
                aria-label='Close'
                (click)='download();'>
          <pt-icon [key]='IconDownload' [size]='18'></pt-icon>
        </button>
      </ng-container>
    </pt-full-dialog-header>

    <div class='modal-body modal-body--full' *ngIf='pdf' (click)='activeModal.close(false)'>
      <div class='pdf-container' (click)='$event.stopPropagation()'>
        <pdf-viewer
          class="h-100"
          [src]='pdfObjectUrl'
          [zoom]='pdfZoom'
          (click)='$event.stopPropagation(); clickPdf($event)'
          [fit-to-page]='true'
          [autoresize]='true'
          [(page)]='currentPage'
          [render-text]='true'
          [show-all]='true'
          [stick-to-page]='true'
          [show-borders]='false'
          (pages-initialized)='pageInitialized($event)'
        ></pdf-viewer>

      </div>
    </div>
  `,
  styleUrls: [`html-preview-dialog.component.scss`]
})
export class HtmlPreviewDialogComponent {
  pdf: DownloadResponse;
  title: Observable<string>;
  pdfZoom = 1;
  width = 810;
  padding = 2 * this.width / 21;
  IconClose = IoniconsOutline.arrowLeft;
  IconDownload = IoniconsOutline.download;
  IconPrint = IoniconsOutline.print;
  IconFile = IoniconsOutline.file;


  currentPage = 1;
  totalPage = 0;

  public pdfObjectUrl: string;

  maxPdfZoom = MAX_PDF_ZOOM;
  minPdfZoom = MIN_PDF_ZOOM;
  pdfZoomStep = PDF_ZOOM_STEP;
  disabledZoomDown = false;
  disabledZoomUp = false;


  constructor(public activeModal: NgbActiveModal) {
  }


  run(title: Observable<string>, pdf: DownloadResponse) {
    this.title = title;
    this.pdf = pdf;
    this.pdfObjectUrl = URL.createObjectURL(new Blob([this.pdf.blob], {type: 'application/pdf'}));

    document.addEventListener('keydown', (event) => {
      switch (event.keyCode) {
        case 33:
          if (this.currentPage > 1) {
            this.currentPage--;
          }
          break;
        case 34:
          if (this.currentPage < this.totalPage) {
            this.currentPage++;
          }
          break;
      }
    });
  }

  pageInitialized($event: any) {
    this.totalPage = $event?.source?._pages?.length;
  }

  download() {
    FileSaver.saveAs(this.pdf.blob, this.pdf.fileName + '.pdf');
  }

  print() {
    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);
    iframe.style.display = 'none';
    iframe.src = this.pdfObjectUrl;
    iframe.onload = () => {
      setTimeout(() => {
        iframe.focus();
        iframe.contentWindow.print();
      }, 50);
    };
  }

  clickPdf(event) {
    const cssClass: string = event?.target?.className;
    // il div contenitore del pdf della libreria ha questa classe.
    // qui verifico se il click del tag della libreria è in questa classe (area nera esterna) oppure no. Se si chiudo la modale
    if (cssClass?.indexOf('pdfViewer') !== -1) {
      this.activeModal.close(true);
    }
  }


  zoomDown() {
    if (this.pdfZoom > this.minPdfZoom) {
      this.pdfZoom -= this.pdfZoomStep;
    }
    this.checkZoomButton();
  }

  zoomMax() {
    this.pdfZoom = this.pdfZoom >= this.maxPdfZoom ? 1 : this.maxPdfZoom;
    this.checkZoomButton();
  }

  zoomUp() {
    if (this.pdfZoom < this.maxPdfZoom) {
      this.pdfZoom += this.pdfZoomStep;
    }
    this.checkZoomButton();
  }

  private checkZoomButton() {
    this.disabledZoomDown = this.pdfZoom <= this.minPdfZoom;
    this.disabledZoomUp = this.pdfZoom >= this.maxPdfZoom;
  }
}

